import react, {useEffect, useState} from 'react'
import {RouterProvider} from 'react-router-dom';
import router from '../../router'
import './style.css'


export const Application: react.FC = () => {
    const [suffix, setSuffix] = useState('');
    const [update, setUpdate] = useState(false);

    useEffect(() => {
        var splittedHref = window.location.href.split('/')
        setSuffix(splittedHref[splittedHref.length - 1]);
        window.onhashchange = () => {
            setUpdate(!update);
        }

    }, [update]);


    return <div className='app__container'>
        <RouterProvider router={router}/>
    </div>
}